<label class="checkbox-label" [class.label-left]="labelPosition === 'left'">
  @if (labelPosition === 'left' && label) {
  <span class="checkbox-text">{{ label }}</span>
  }
  <div class="checkbox-container">
    <input type="checkbox" class="checkbox" [checked]="value" [disabled]="disabled"
      (change)="onCheckboxChange($event)" />
    @if (value) {
    <app-icon name="check" [size]="20" [strokeWidth]="4" class="checkbox-icon" />
    }
  </div>
  @if (labelPosition === 'right' && label) {
  <span class="checkbox-text">{{ label }}</span>
  }
  <ng-content></ng-content>
</label>